export enum MaltClassicCreationStepRoute {
    SIGNUP_HEADLINE = '/signup/headline',
    SIGNUP_CATEGORIZATION = '/signup/categorization',
    SIGNUP_EXPERTISE = '/signup/expertise',
    SIGNUP_DAILY_RATE = '/signup/daily-rate',
    SIGNUP_LOCALISATION = '/signup/localisation',
    COMPLETION_LINKEDIN = '/completion/linkedin-import',
    COMPLETION_EXPERIENCE = '/completion/experience',
    COMPLETION_EDUCATION = '/completion/education',
    COMPLETION_DESCRIPTION = '/completion/description',
    COMPLETION_RECOMMENDATION = '/completion/recommendation',
    COMPLETION_PRIVACY = '/completion/privacy',
}

export enum MaltStrategyCreationStepRoute {
    SIGNUP_INTRODUCTION = '/signup/strategy/introduction',
    SIGNUP_USE_CASE = '/signup/strategy/use-case',
    SIGNUP_HEADLINE = '/signup/strategy/headline',
    SIGNUP_CATEGORIZATION = '/signup/strategy/categorization',
    SIGNUP_EXPERTISE = '/signup/strategy/functional-skills',
    SIGNUP_INDUSTRY_EXPERTISE = '/signup/strategy/industry-expertise',
    SIGNUP_DAILY_RATE = '/signup/strategy/daily-rate',
    SIGNUP_LOCALISATION = '/signup/strategy/localisation',
    COMPLETION_LINKEDIN = '/completion/strategy/linkedin-import',
    COMPLETION_EXPERIENCE = '/completion/strategy/experience',
    COMPLETION_EDUCATION = '/completion/strategy/education',
    COMPLETION_DESCRIPTION = '/completion/strategy/description',
    COMPLETION_PRIVACY = '/completion/strategy/privacy',
    COMPLETION_SUBMIT_APPLICATION = '/completion/strategy/submit-application',
    WAITING_ROOM = '/waiting-room/strategy',
}

export enum OldCreationStepRoute {
    SIGNUP_HEADLINE = '/signup/headline',
    SIGNUP_CATEGORIZATION = '/signup/categorization',
    SIGNUP_EXPERTISE = '/signup/expertise',
    SIGNUP_LOCALISATION = '/signup/localisation',
    COMPLETION_DESCRIPTION = '/completion/description',
    COMPLETION_RECOMMENDATION = '/completion/recommendation',
    COMPLETION_PRIVACY = '/completion/privacy',
}
